// src/views/menage/SectionControleursDefaut.jsx — « QUI CONTRÔLE QUOI PAR
// DÉFAUT » (3e ligne du panneau Planning, demande Dimitri 2026-08-21).
// Même dessin, même comportement que « Qui s'occupe de quoi par défaut » et
// « Durées par logement » : la liste des logements, et pour chacun son
// contrôleur habituel, MODIFIABLE SUR PLACE (portée LOGEMENT — la même
// écriture que la case du menu de désignation et rien d'autre).
//
//   · « aucun contrôleur » en AMBRE — une information, pas un vide ;
//   · un désigné SORTI DU POOL : « désigné mais sans accès » en ambre — la
//     désignation reste écrite mais ne compte plus (le serveur l'ignore
//     aussi dans la liste À contrôler) ;
//   · SYNCHRO : écrit via designerControleurLogement → l'événement
//     `fbz:controle-designation` fait recharger les trois chemins.

import { useState } from 'react'
import React from 'react'
import useEtroit from '../../lib/useEtroit'
import RangeePastillesAgents from './RangeePastillesAgents'
import { DS } from '../../lib/ui'
import { designerControleurLogement } from '../../lib/panneau-menage-api'
import { CircleAlert } from 'lucide-react'

const AMBRE_FOND = '#fdf7ee'
const AMBRE_TEXTE = '#8a5f19'

export default function SectionControleursDefaut({ logements, defauts, prenoms, selfEmail, onChange }) {
  const [enCours, setEnCours] = useState(null) // logement_id en écriture
  const [erreur, setErreur] = useState(null)

  // Les désignables : le pool (+ soi) — les clés de la carte des prénoms.
  const emailsPool = Object.keys(prenoms || {})
  const prenomDe = (email) => (prenoms || {})[email] || String(email || '').split('@')[0]

  const ecrire = async (logementId, email) => {
    setEnCours(logementId); setErreur(null)
    const r = await designerControleurLogement({
      logementId, controleurEmail: email || null,
    })
    if (!r.ok) setErreur(r.erreur)
    setEnCours(null)
    if (onChange) onChange()
  }

  // TÉLÉPHONE (correction 22/08) : le choix du contrôleur au plus près de la
  // ligne — pastilles 44 px, plus de <select> natif. Ordinateur inchangé.
  const etroit = useEtroit()
  return (
    <div data-testid="section-controleurs-defaut"
      style={{ background: '#fff', border: '1px solid #d5e3ee', borderRadius: 12,
        padding: '13px 14px', fontFamily: DS.fontBody }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#233240',
        textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 10 }}>
        Qui contrôle quoi par défaut
      </div>
      {erreur && (
        <div style={{ display: 'flex', gap: 7, alignItems: 'center', padding: '8px 11px',
          background: DS.dangerBg, color: DS.dangerText, borderRadius: 9,
          fontSize: 12, marginBottom: 9 }}>
          <CircleAlert size={14} strokeWidth={2.2} style={{ flexShrink: 0 }} /> {erreur}
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {(logements || []).map((l, i) => {
          const defaut = (defauts || {})[l.id] || null
          const sansAcces = !!defaut && !emailsPool.includes(defaut)
          return (
            <React.Fragment key={l.id}>
            <div data-testid={`controleur-defaut-${l.id}`}
              style={{ display: 'flex', alignItems: 'center', gap: 10, minHeight: 42,
                borderBottom: (!etroit && i < logements.length - 1) ? '1px solid #f2f4f6' : 'none',
                padding: '4px 0' }}>
              <span style={{ flex: 1, minWidth: 0, fontSize: 12.5, fontWeight: 600,
                color: '#233240', overflow: 'hidden', textOverflow: 'ellipsis',
                whiteSpace: 'nowrap' }}>
                {l.nom}
              </span>
              {/* L'ÉTAT dit ce qui est — jamais un vide muet. */}
              {!defaut && (
                <span data-testid={`controleur-defaut-aucun-${l.id}`}
                  style={{ flexShrink: 0, fontSize: 10.5, fontWeight: 700, padding: '3px 9px',
                    borderRadius: 7, background: AMBRE_FOND, color: AMBRE_TEXTE }}>
                  aucun contrôleur
                </span>
              )}
              {sansAcces && (
                <span data-testid={`controleur-defaut-sans-acces-${l.id}`}
                  title={`${prenomDe(defaut)} n'a plus accès à ce logement — la désignation ne compte plus.`}
                  style={{ flexShrink: 0, fontSize: 10.5, fontWeight: 700, padding: '3px 9px',
                    borderRadius: 7, background: AMBRE_FOND, color: AMBRE_TEXTE }}>
                  désigné mais sans accès
                </span>
              )}
              {!etroit && (
              <select
                data-testid={`controleur-defaut-select-${l.id}`}
                value={defaut && !sansAcces ? defaut : ''}
                disabled={enCours === l.id}
                onChange={(e) => ecrire(l.id, e.target.value || null)}
                aria-label={`Contrôleur habituel de ${l.nom}`}
                style={{ flexShrink: 0, minHeight: 34, border: '0.5px solid #c3d5e4',
                  borderRadius: 9, padding: '4px 8px', fontSize: 12, fontFamily: DS.fontBody,
                  background: '#fff', color: '#233240', maxWidth: 170 }}>
                <option value="">— aucun —</option>
                {emailsPool.map((email) => (
                  <option key={email} value={email}>
                    {prenomDe(email)}{email === selfEmail ? ' (moi)' : ''}
                  </option>
                ))}
                {/* Un sans-accès reste LISIBLE dans la liste déroulante le
                    temps de choisir son remplaçant. */}
                {sansAcces && (
                  <option value={defaut} disabled>
                    {prenomDe(defaut)} (sans accès)
                  </option>
                )}
              </select>
              )}
            </div>
            {etroit && (
              <RangeePastillesAgents testPrefix={`controleur-defaut-${l.id}`}
                occupe={enCours === l.id}
                actif={defaut && !sansAcces ? defaut : ''}
                onChoisir={(v) => ecrire(l.id, v || null)}
                options={[
                  { value: '', label: '— aucun —' },
                  ...emailsPool.map((email) => ({
                    value: email,
                    label: `${prenomDe(email)}${email === selfEmail ? ' (moi)' : ''}`,
                  })),
                  ...(sansAcces ? [{ value: defaut, label: `${prenomDe(defaut)} (sans accès)`, disabled: true }] : []),
                ]} />
            )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}
